export default __webpack_public_path__ + "static/media/storage_size_2.746756b3.png";